export default function Marquee() {
  const text = "MARTEGIANI PETROLI — AFFIDABILITÀ E SOLIDITÀ — GASOLIO E LUBRIFICANTI — MONTORIO AL VOMANO —";
  return (
    <div className="bg-orange text-white py-4 overflow-hidden border-y border-orange" data-testid="marquee">
      <div className="marquee-track">
        {[0, 1].map((i) => (
          <span key={i} className="font-display text-xl md:text-2xl tracking-tight px-4">
            {text.repeat(1)}
          </span>
        ))}
      </div>
    </div>
  );
}
